export { default } from './retailers.vue'
